module.exports = __webpack_public_path__ + "static/media/brand-logo.39871bf3.png";